// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__177zO","rootMobile":"styles_rootMobile__eSEKH"};